import { render } from "./PropostasRematricula.vue?vue&type=template&id=c8215052"
import script from "./PropostasRematricula.vue?vue&type=script&lang=js"
export * from "./PropostasRematricula.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__